import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  @Input() colored: boolean = true;
  @Input() scrolled: boolean = false;
  @Input() opened: boolean = false;
}
